export default __webpack_public_path__ + "static/media/queen.f79fd14b.jpg";